import { render } from "./CashAccountAgreement.vue?vue&type=template&id=0ac87143&scoped=true&ts=true"
import script from "./CashAccountAgreement.vue?vue&type=script&lang=ts"
export * from "./CashAccountAgreement.vue?vue&type=script&lang=ts"

import "./CashAccountAgreement.vue?vue&type=style&index=0&id=0ac87143&scoped=true&lang=css"
import "./CashAccountAgreement.vue?vue&type=style&index=1&id=0ac87143&scoped=true&lang=scss"

import exportComponent from "/Users/pradipdobariya/Documents/projects/DMA Global/caprock-merchant-old/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ac87143"]])

export default __exports__